import styled, { css } from 'styled-components';
import { BubbleProps } from './Bubble';
import { bubbleTokens } from '../../tokens/components/Bubble/tokens';

/* @internal */
export const equityVariants = {
  'equity-common': {
    background: bubbleTokens.BackgroundColorCommonDefault,
    border: bubbleTokens.BackgroundColorCommonDefault,
    text: bubbleTokens.FontColorCommonDefault,
  },
  'equity-preferred': {
    background: bubbleTokens.BackgroundColorPreferredDefault,
    border: bubbleTokens.BackgroundColorPreferredDefault,
    text: bubbleTokens.FontColorPreferredDefault,
  },
  'equity-convertible': {
    background: bubbleTokens.BackgroundColorConvertibleDefault,
    border: bubbleTokens.BackgroundColorConvertibleDefault,
    text: bubbleTokens.FontColorConvertibleDefault,
  },
  'equity-warrant': {
    background: bubbleTokens.BackgroundColorWarrantDefault,
    border: bubbleTokens.BackgroundColorWarrantDefault,
    text: bubbleTokens.FontColorWarrantDefault,
  },
  'equity-option': {
    background: bubbleTokens.BackgroundColorOptionDefault,
    border: bubbleTokens.BackgroundColorOptionDefault,
    text: bubbleTokens.FontColorOptionDefault,
  },
  'equity-pool': {
    background: bubbleTokens.BackgroundColorPoolDefault,
    border: bubbleTokens.BackgroundColorPoolDefault,
    text: bubbleTokens.FontColorPoolDefault,
  },
};

/* @internal */
export const bubbleVariants = {
  'feedback-positive': {
    background: bubbleTokens.BackgroundColorPositiveDefault,
    border: bubbleTokens.BackgroundColorPositiveDefault,
    text: bubbleTokens.FontColorPositiveDefault,
  },
  'feedback-notice': {
    background: bubbleTokens.BackgroundColorNoticeDefault,
    border: bubbleTokens.BackgroundColorNoticeDefault,
    text: bubbleTokens.FontColorNoticeDefault,
  },
  'feedback-negative': {
    background: bubbleTokens.BackgroundColorNegativeDefault,
    border: bubbleTokens.BackgroundColorNegativeDefault,
    text: bubbleTokens.FontColorNegativeDefault,
  },
  'feedback-neutral': {
    background: bubbleTokens.BackgroundColorNeutralDefault,
    border: bubbleTokens.BackgroundColorNeutralDefault,
    text: bubbleTokens.FontColorNeutralDefault,
  },
  'feedback-pending': {
    background: bubbleTokens.BackgroundColorPendingDefault,
    border: bubbleTokens.BackgroundColorPendingDefault,
    text: bubbleTokens.FontColorPendingDefault,
  },
  'feedback-informational': {
    background: bubbleTokens.BackgroundColorInformationalDefault,
    border: bubbleTokens.BackgroundColorInformationalDefault,
    text: bubbleTokens.FontColorInformationalDefault,
  },
  'feedback-staff': {
    background: bubbleTokens.BackgroundColorStaffDefault,
    border: bubbleTokens.BackgroundColorStaffDefault,
    text: bubbleTokens.FontColorStaffDefault,
  },
  ...equityVariants,
};

/* @internal */
export const bubbleTypes = {
  staff: {
    background: bubbleTokens.BackgroundColorStaffDefault,
    border: bubbleTokens.BackgroundColorStaffDefault,
    text: bubbleTokens.FontColorStaffDefault,
  },
  purple: {
    background: bubbleTokens.BackgroundColorPurpleDefault,
    border: bubbleTokens.BorderColorPurpleDefault,
    text: bubbleTokens.FontColorPurpleDefault,
  },
  'blue-dark': {
    background: bubbleTokens.BackgroundColorBlueDarkDefault,
    border: bubbleTokens.BorderColorBlueDarkDefault,
    text: bubbleTokens.FontColorBlueDarkDefault,
  },
  gray: {
    background: bubbleTokens.BackgroundColorGrayDefault,
    border: bubbleTokens.BorderColorGrayDefault,
    text: bubbleTokens.FontColorGrayDefault,
  },
  white: {
    background: bubbleTokens.BackgroundColorWhiteDefault,
    border: bubbleTokens.BorderColorWhiteDefault,
    text: bubbleTokens.FontColorWhiteDefault,
  },
  green: {
    background: bubbleTokens.BackgroundColorGreenDefault,
    border: bubbleTokens.BorderColorGreenDefault,
    text: bubbleTokens.FontColorGreenDefault,
  },
  red: {
    background: bubbleTokens.BackgroundColorRedDefault,
    border: bubbleTokens.BorderColorRedDefault,
    text: bubbleTokens.FontColorRedDefault,
  },
  orange: {
    background: bubbleTokens.BackgroundColorOrangeDefault,
    border: bubbleTokens.BorderColorOrangeDefault,
    text: bubbleTokens.FontColorOrangeDefault,
  },
  yellow: {
    background: bubbleTokens.BackgroundColorYellowDefault,
    border: bubbleTokens.BorderColorYellowDefault,
    text: bubbleTokens.FontColorYellowDefault,
  },
  blue: {
    background: bubbleTokens.BackgroundColorBlueDefault,
    border: bubbleTokens.BorderColorBlueDefault,
    text: bubbleTokens.FontColorBlueDefault,
  },
  'gray-light': {
    background: bubbleTokens.BackgroundColorGrayLightDefault,
    border: bubbleTokens.BorderColorGrayLightDefault,
    text: bubbleTokens.FontColorGrayLightDefault,
  },
};

/* @internal */
export const StyledBubble = styled.span<BubbleProps>`
  align-items: center;
  border-radius: ${bubbleTokens.BorderRadiusBaseDefault};
  border-style: ${bubbleTokens.BorderStyleBaseDefault};
  border-width: ${bubbleTokens.BorderWidthBaseDefault};
  display: inline-flex;
  font-family: ${bubbleTokens.FontFamilyBaseDefault};
  font-size: ${bubbleTokens.FontSizeBaseDefault};
  font-weight: ${bubbleTokens.FontWeightBaseDefault};
  letter-spacing: 0.02rem;
  line-height: 1;
  min-width: fit-content;
  padding: ${bubbleTokens.SpacingInnerVerticalBaseDefault} ${bubbleTokens.SpacingInnerHorizontalBaseDefault};
  position: relative;
  text-align: center;

  ${({ theme }) =>
    theme.type &&
    css`
      background-color: ${bubbleTypes[theme.type].background};
      border-color: ${bubbleTypes[theme.type].border};
      color: ${bubbleTypes[theme.type].text};
    `};

  ${({ theme }) =>
    theme.variant &&
    css`
      background-color: ${bubbleVariants[theme.variant].background};
      border-color: ${bubbleVariants[theme.variant].border};
      color: ${bubbleVariants[theme.variant].text};
    `};
`;
